import { Mode } from "react-day-picker";
import { ElementFactory, Question, Serializer } from "survey-core";

export const CALENDAR_QUESTION_TYPE = "calendar";

export class QuestionCalendarModel extends Question {

  constructor(name: string) {
    super(name);
    this.addExpressionProperty(
      "disableBeforeValue",
      (obj, res) => {
        if (res) {
          (obj as any).disableBefore = res;
        }
      }
    );
  }

  getType() {
    return CALENDAR_QUESTION_TYPE;
  }

  get mode() {
    return this.getPropertyValue("mode");
  }

  set mode(value: Mode) {
    this.setPropertyValue("mode", value);
  }

  get numberOfMonths() {
    return this.getPropertyValue("numberOfMonths");
  }

  set numberOfMonths(value: number) {
    this.setPropertyValue("numberOfMonths", value);
  }

  get disableBefore() {
    return this.getPropertyValue("disabledBefore");
  }

  set disableBefore(value: Date) {
    this.setPropertyValue("disabledBefore", value);
  }

  get disableBeforeValue() {
    return this.getPropertyValue("disableBeforeValue");
  }

  set disableBeforeValue(value: string) {
    this.setPropertyValue("disableBeforeValue", value);
  }

}

export function registerCalendar() {
  ElementFactory.Instance.registerElement(CALENDAR_QUESTION_TYPE, (name) => {
    return new QuestionCalendarModel(name);
  });

  Serializer.addClass(
    CALENDAR_QUESTION_TYPE,
    [
      {
        name: "mode",
        default: "single",
        choices: ["single", "multiple", "range"],
        category: "general",
        visibleIndex: 2,
      },
      {
        name: "numberOfMonths",
        default: 1,
        type: "number",
        minValue: 1,
        maxValue: 12,
        category: "general",
        visibleIndex: 3,
      },
      {
        name: "disableBeforeValue",
        default: undefined,
        type: "expression",
        category: "general",
        visibleIndex: 3,
      },
      {
        name: "disableBefore",
        default: undefined,
        type: "date",
        category: "general",
        visibleIndex: 4,
      },
    ],
    function () {
      return new QuestionCalendarModel("");
    },
    "question"
  );
}
